import useGlobalState from './useGlobalState.hooks';
import { useStatsigLayer } from './useStatsigLayer.hook';

export const useHeaderCtaCopy = (contentfulButtonText: string) => {
  const { isLoggedIn } = useGlobalState();
  const { get: getAnonymous, isReady: isAnonymousReady } = useStatsigLayer('track_my_parcel_copy_layer');
  const { get: getSignedIn, isReady: isSignedInReady } = useStatsigLayer('track_my_parcel_signed_in_layer');

  const fallback = { headerCtaCopy: contentfulButtonText };

  if (!isAnonymousReady || !isSignedInReady) return fallback;

  const get = isLoggedIn ? getSignedIn : getAnonymous;
  const statsigValue = get('header_cta_copy', '');

  return {
    headerCtaCopy: statsigValue || contentfulButtonText,
  };
};
